export enum GlobalSearchType {
  CLIENT = "CLIENT",
  CONTRACT = "CONTRACT",
  AGENT = "AGENT",
  USER = "USER",
  NAVIGATION = "NAVIGATION",
  FINANCIAL_MEDIATION = "FINANCIAL_MEDIATION",
}
